import React from "react";
import { usePostBrandMutation } from "../../../../store";
import { setBrand } from "../../../../store/slices/applicationManagement/managementSlice";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import { BRAND_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { useFormik } from "formik";
import brandValidation from "../utils/brandValidation";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";

function BrandForm() {
  const dispatch = useDispatch();
  const { brandDialogOpen } = useSelector((state) => state.dialogSlice);
  const { brand } = useSelector((state) => state.managementSlice);
  const [postBrand, { isLoading }] = usePostBrandMutation();
  const handleClose = () => {
    dispatch(setBrand(null));
    dispatch(closeDialog(BRAND_DIALOG));
  };
  const formik = useFormik({
    initialValues: {
      id: brand?.id ?? 0,
      name: brand?.name ?? "",
    },
    validationSchema: brandValidation,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      try {
        postBrand({
          id: formik.values.id,
          name: formik.values.name,
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("Marka Kaydedildi !"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  return (
    <Modal
      open={brandDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          Marka Kaydet
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Marka Adı"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            autoFocus
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default BrandForm;
